var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowUpSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25323 14.3263C2.38342 14.3263 1.9273 13.2957 2.51318 12.6542L11.2599 3.07616C11.6571 2.64128 12.3429 2.64128 12.7401 3.07616L21.4868 12.6542C22.0727 13.2957 21.6166 14.3263 20.7468 14.3263H16.4056V20.2508C16.4056 20.8027 15.9573 21.25 15.4043 21.25H8.59571C8.04273 21.25 7.59445 20.8027 7.59445 20.2508V14.3263H3.25323Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpSolid);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjI1MzIzIDE0LjMyNjNDMi4zODM0MiAxNC4zMjYzIDEuOTI3MyAxMy4yOTU3IDIuNTEzMTggMTIuNjU0MkwxMS4yNTk5IDMuMDc2MTZDMTEuNjU3MSAyLjY0MTI4IDEyLjM0MjkgMi42NDEyOCAxMi43NDAxIDMuMDc2MTZMMjEuNDg2OCAxMi42NTQyQzIyLjA3MjcgMTMuMjk1NyAyMS42MTY2IDE0LjMyNjMgMjAuNzQ2OCAxNC4zMjYzSDE2LjQwNTZWMjAuMjUwOEMxNi40MDU2IDIwLjgwMjcgMTUuOTU3MyAyMS4yNSAxNS40MDQzIDIxLjI1SDguNTk1NzFDOC4wNDI3MyAyMS4yNSA3LjU5NDQ1IDIwLjgwMjcgNy41OTQ0NSAyMC4yNTA4VjE0LjMyNjNIMy4yNTMyM1oiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };